import { api } from "@/lib/api";

export interface CommentAttachment {
	id: string;
	comment_id: string;
	file_url: string;
	file_path: string;
	file_name: string;
	mime_type: string;
	file_size: number;
	uploaded_by: string | null;
	created_at: string;
}

function readFileAsDataUrl(file: File): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			if (typeof reader.result === "string") {
				resolve(reader.result);
			} else {
				reject(new Error("Failed to read file."));
			}
		};
		reader.onerror = () => reject(new Error("Failed to read file."));
		reader.readAsDataURL(file);
	});
}

export async function uploadCommentAttachment(
	projectId: string,
	taskId: string,
	commentId: string,
	file: File,
): Promise<CommentAttachment> {
	const dataUrl = await readFileAsDataUrl(file);
	const res = await api.post<{
		success: boolean;
		data: CommentAttachment;
	}>(
		`/projects/${projectId}/tasks/${taskId}/comments/${commentId}/attachments`,
		{
			data: dataUrl,
			content_type: file.type,
			file_name: file.name,
		},
	);
	return res.data;
}

export async function deleteCommentAttachment(
	projectId: string,
	taskId: string,
	commentId: string,
	attachmentId: string,
): Promise<void> {
	await api.delete(
		`/projects/${projectId}/tasks/${taskId}/comments/${commentId}/attachments/${attachmentId}`,
	);
}
